import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import StoreFinder from "@/components/home/StoreFinder";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";
import { useSeo, JsonLd } from "@/lib/seo";
import { track } from "@/lib/track";

const KARAD_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "IceCreamShop",
  name: "RIFIC – Karad",
  telephone: "+917249288910",
  email: "rific.india@gmail.com",
  url: "https://rific.in",
  sameAs: ["https://www.instagram.com/rific.india"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Opp. SGM College, SGM College Road, Sadichha Colony, Vidyanagar, Saidapur",
    addressLocality: "Karad",
    addressRegion: "Maharashtra",
    postalCode: "415124",
    addressCountry: "IN",
  },
};

export default function Stores() {
  useSeo({
    title: "RIFIC Karad | Ice Cream, Desserts & Shakes",
    description:
      "Visit RIFIC Karad at SGM College Road, Vidyanagar, Saidapur, Karad for ice cream, desserts, shakes and seasonal flavours.",
    path: "/stores",
  });

  useEffect(() => track("store_view"), []);

  return (
    <div data-testid="stores-page">
      <JsonLd data={KARAD_SCHEMA} />
      <PageHeader
        eyebrow="Stores"
        title={["FIND RIFIC."]}
        copy="RIFIC stores are designed to be spotted — bold orange on the outside, warm cream on the inside. Walk in for scoops, sundaes, waffles, shakes and coolers."
        img={IMG.storefront}
      />

      <StoreFinder />

      <section className="bg-cream py-16 text-center md:py-20">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <Reveal>
            <p className="font-display text-2xl font-bold tracking-[-0.01em] text-deep md:text-3xl">
              Your city could be next.
            </p>
            <Link
              to="/franchise#franchise-form"
              data-testid="stores-franchise-cta"
              onClick={() => track("franchise_cta_click", { placement: "stores_page" })}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-orange-rific px-8 py-4 text-sm font-bold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-deep"
            >
              Own a RIFIC
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
